import React, { useState } from "react";
import { InputGroup, Button, Intent } from "@blueprintjs/core";
export default function PasswordInput(props) {
  const [showPassword, setShowPassword] = useState(false);
  const lockButton = (
    <Button
      tabIndex={-1}
      title={`${showPassword ? "Hide" : "Show"} Password`}
      icon={showPassword ? "unlock" : "lock"}
      intent={Intent.WARNING}
      minimal={true}
      onClick={() => setShowPassword(!showPassword)}
    />
  );
  return (
    <InputGroup
      {...props}
      rightElement={lockButton}
      type={showPassword ? "text" : "password"}
    />
  );
}
